import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {authAxios} from "../../api/axiosClient";
import {statusApprovalOTURL, statusURL} from "../../constants";

const initialState = {
    status: 'idle',
    systemStatus:{},
    systemOTStatus:{},
    systemGroup:[],
    systemOTGroup:[],
    error:null
};

const getSystemRule =(data)=>{
    let objGroup = data.map(item=>({group:item.groupDuyet,status:item.sortDuyet}))
    return objGroup
}

export const getSystemStatus = createAsyncThunk(
  'system/getSystemInfo',
  async (token,{rejectWithValue}) => {
    try {
      const response = await authAxios().get(statusURL);
      return response.data;
    }
    catch (e) {
      return rejectWithValue(e.response.data);
    }
  }
);

export const getSystemOTStatus = createAsyncThunk(
  'system/getSystemOTInfo',
  async (token,{rejectWithValue}) => {
    try {
      const response = await authAxios().get(statusApprovalOTURL);
      return response.data;
    }
    catch (e) {
      return rejectWithValue(e.response.data);
    }
  }
);

export const systemSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSystemStatus.pending, (state) => {
        state.status = 'loading';

      })
      .addCase(getSystemStatus.fulfilled, (state, action) => {
        state.status = 'idle';
        state.systemStatus = action.payload;
        state.systemGroup = getSystemRule(action.payload)
      })
      .addCase(getSystemStatus.rejected, (state, action) => {
        state.status = 'idle';
      })
        .addCase(getSystemOTStatus.pending, (state) => {
        state.status = 'loading';

      })
      .addCase(getSystemOTStatus.fulfilled, (state, action) => {
        state.status = 'idle';
        state.systemOTStatus = action.payload;
        state.systemOTGroup = getSystemRule(action.payload)
      })
      .addCase(getSystemOTStatus.rejected, (state, action) => {
        state.status = 'idle';
      })
  },
});

export default systemSlice.reducer;